import { IonBackButton, IonButtons, IonCol, IonContent, IonGrid, IonPage, IonRow, IonTitle, isPlatform } from "@ionic/react";
import { RouteComponentProps } from "react-router";
import { Header } from "../../components";

import "./Legal.scss";

interface ImprintProps extends RouteComponentProps<{}> { };

const Imprint: React.FC<ImprintProps> = () => {
    return (
        <IonPage>
            <Header>
                <IonButtons slot="start">
                    <IonBackButton text={isPlatform('ios') ? "Zurück" : undefined} />
                </IonButtons>
                <IonTitle>Impressum</IonTitle>
            </Header>
            <IonContent>
                <IonGrid fixed={true} className="mainContent">
                    <IonRow>
                        <IonCol size="12">
                            <div className="legalContent">
                                <h2>Impressum</h2>
                                <div>
                                    <p>Angaben gemäß § 5 TMG:</p>
                                    <p>
                                        <strong>Hachenbach Präzisionswerkzeuge GmbH &amp; Co. KG</strong><br />
                                        Greifenthaler Straße 14-16<br />
                                        D-35630 Ehringshausen-Katzenfurt
                                    </p>

                                    <p>
                                        <strong>Vertreten durch:</strong><br />
                                        Carsten Hachenbach / Geschäftsführer
                                    </p>

                                    <p>
                                        <strong>Kontakt:</strong><br />
                                        Tel.: +49 (0) 6449/7177-0<br />
                                        Fax: +49 (0) 6449/7177-22<br />
                                        Email: <a href="mailto:info@hachenbach.de">info@hachenbach.de</a><br />
                                        Web: <a href="https://www.hachenbach.de" target="_blank" rel="noreferrer">www.hachenbach.de</a>
                                    </p>

                                    <p>
                                        <strong>Registereintrag:</strong><br />
                                        Eintragung im Handelsregister.<br />
                                        Registergericht: Amtsgericht Wetzlar<br />
                                        Registration number: HRB 788<br />
                                        Registration number: HRA 2919
                                    </p>

                                    <p>
                                        <strong>Umsatzsteuer-ID:</strong><br />
                                        Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                                        DE 113742195
                                    </p>

                                    <p>
                                        <strong>Streitschlichtung</strong><br />
                                        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                                    </p>


                                    <h3 className="legalTitle">Haftungsausschluss (Disclaimer)</h3>
                                    <p>
                                        <strong>Haftung für Inhalte</strong><br />
                                        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                                    </p>
                                    <p>
                                        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                                    </p>

                                    <p>
                                        <strong>Haftung für Links</strong><br />
                                        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
                                        Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                                    </p>
                                    <p>
                                        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                                    </p>

                                    <p>
                                        <strong>Urheberrecht</strong><br />
                                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                                    </p>
                                    <p>
                                        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.

                                    </p>
                                </div>

                            </div>
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </IonContent>
        </IonPage>
    )
}

export default Imprint;